"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeFormatter = exports.handleTokenizedString = exports.calculateTimer = exports.calculateHours = void 0;
const calculateHours = (date2, date1) => {
  let diff = (date2.getTime() - date1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
};
exports.calculateHours = calculateHours;
const timeFormatter = (date, timeOptions) => {
  const time = date.toLocaleString('en-US', timeOptions);
  const timeFormat = time.split(' ').join('').toLowerCase();
  return timeFormat;
};
exports.timeFormatter = timeFormatter;
const calculateTimer = data => {
  const {
    endDate,
    timerMeta,
    monthOptions,
    timeOptions
  } = data || {};
  if (!endDate) {
    return {
      label: null
    };
  }
  let label = null;

  // Set the date we're counting down to
  const countDownDate = new Date(endDate).getTime();

  // Get today's date and time
  const now = new Date().getTime();

  // Find the distance between now and the count down date
  const distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(distance % (1000 * 60) / 1000);
  if (days >= 2) {
    label = timerMeta.endsLabel.replace('%1', `${endDate.toLocaleString('en-US', monthOptions)} |  ${timeFormatter(endDate, timeOptions)}`);
  } else if (days < 2 && days >= 1) {
    label = timerMeta.endsInLabel.replace('%1', `${days}d ${hours}hr`);
  } else if (days < 1 && hours >= 1) {
    label = timerMeta.endsInLabel.replace('%1', `${hours}h ${minutes}m`);
  } else if (days < 1 && hours <= 1 && minutes >= 1) {
    label = timerMeta.endsInLabel.replace('%1', `${minutes}m`);
  } else if (days < 1 && hours < 1 && minutes < 1 && seconds > 1) {
    label = timerMeta.endsInLabel.replace('%1', `${seconds}s`);
  } else if (days < 1 && hours < 1 && minutes < 1 && seconds < 1) {
    label = timerMeta.offerEndedLabel;
  }
  return label;
};

// tokenizedStringFormatter
/**
 * This method takes the tokenizedString, values as a parameter,
 * return the updated tokenized string
 * @param  {String} tokenizedString - gets slide %x of %totalLength from CMS
 * @param  {Array} values - [array index count starts with 1, total length of array]
 */
exports.calculateTimer = calculateTimer;
const handleTokenizedString = function (tokenizedString) {
  let values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!tokenizedString) {
    return null;
  }
  if (!values || tokenizedString && !tokenizedString.includes('%')) {
    return tokenizedString;
  }
  let tokenizedValue = tokenizedString;
  values.forEach((val, index) => {
    let token = `%${index + 1}`;
    tokenizedValue = tokenizedValue.replace(token, val);
  });
  return tokenizedValue;
};
exports.handleTokenizedString = handleTokenizedString;